import React from "react";
import LoadingStyle from "./style";
import Logo from "../../Assets/Primis-Logo.svg";

function Loader() {
  return (
    <>
      <div className="loader">
        <img src={Logo} alt="Logo" width="150" />
      </div>
      <LoadingStyle />
    </>
  );
}

export default Loader;
